import { useEffect, useState } from 'react';

// Matches Tailwind's `lg` breakpoint — the Academy Portal's mobile/desktop
// chrome split.
const DESKTOP_QUERY = '(min-width: 1024px)';

export function useIsDesktop() {
  const get = () => typeof window !== 'undefined' && window.matchMedia(DESKTOP_QUERY).matches;
  const [isDesktop, setIsDesktop] = useState(get);
  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY);
    const onChange = () => setIsDesktop(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);
  return isDesktop;
}
